<div class="card">
  <h3 class="card-header">{{ props.label }}</h3>
  <div class="card-body">
    <ng-container #fieldComponent></ng-container>
  </div>
</div>
